(() => {
  if (window.__ATC_DEDUPE_FIX_INSTALLED__) return;
  window.__ATC_DEDUPE_FIX_INSTALLED__ = true;

  const DEBUG = true; 
  const SUBMIT_LOCK_MS = 1500; 
  const DEDUPE_WINDOW_MS = 2000; 

  const inflightAdds = new Map(); // fingerprint -> { ts, promise }
  const recentAdds = new Map();   // fingerprint -> { ts, response }

  function log(...args) {
    if (DEBUG) console.log("[atc-dedupe-fix]", ...args);
  }

  function now() {
    return Date.now();
  }

  function getPath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return String(url || "");
    }
  }

  function isCartAddUrl(url) {
    const path = getPath(url);
    return path === "/cart/add" || path === "/cart/add.js" || path.includes("/cart/add");
  }

  function stableSortObject(value) {
    if (Array.isArray(value)) return value.map(stableSortObject);
    if (value && typeof value === "object") {
      const out = {};
      Object.keys(value)
        .sort()
        .forEach((k) => {
          out[k] = stableSortObject(value[k]);
        });
      return out;
    }
    return value;
  }

  function parseBodyToObject(body) {
    if (!body) return null;

    // JSON string
    if (typeof body === "string") {
      //  JSON
      try {
        return JSON.parse(body);
      } catch (e) {
        //  querystring
        try {
          const p = new URLSearchParams(body);
          const obj = {};
          for (const [k, v] of p.entries()) {
            if (obj[k] !== undefined) {
              if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
              obj[k].push(v);
            } else {
              obj[k] = v;
            }
          }
          return obj;
        } catch (e2) {
          return { raw: body };
        }
      }
    }

    // FormData
    if (window.FormData && body instanceof FormData) {
      const obj = {};
      body.forEach((v, k) => {
        if (obj[k] !== undefined) {
          if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
          obj[k].push(String(v));
        } else {
          obj[k] = String(v);
        }
      });
      return obj;
    }

    // URLSearchParams
    if (window.URLSearchParams && body instanceof URLSearchParams) {
      const obj = {};
      for (const [k, v] of body.entries()) {
        if (obj[k] !== undefined) {
          if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
          obj[k].push(v);
        } else {
          obj[k] = v;
        }
      }
      return obj;
    }

    return null;
  }

  function buildFingerprint(url, bodyObj) {
    if (!bodyObj) return null;

    
    const clone = JSON.parse(JSON.stringify(bodyObj));

    if (clone.quantity == null && clone.id != null && clone.items == null) {
      clone.quantity = "1";
    }

    const sorted = stableSortObject(clone);
    return `${getPath(url)}::${JSON.stringify(sorted)}`;
  }

  function cleanupCaches() {
    const t = now();

    for (const [fp, rec] of inflightAdds.entries()) {
      if (t - rec.ts > 10000) inflightAdds.delete(fp);
    }

    for (const [fp, rec] of recentAdds.entries()) {
      if (t - rec.ts > 10000) recentAdds.delete(fp);
    }
  }

  function patchFetch() {
    if (!window.fetch) return;

    const nativeFetch = window.fetch;

    window.fetch = function patchedFetch(input, init) {
      try {
        const url = typeof input === "string" ? input : input?.url;

        if (!isCartAddUrl(url)) {
          return nativeFetch.apply(this, arguments);
        }

        const bodyObj = parseBodyToObject(init && init.body);
        const fp = buildFingerprint(url, bodyObj);

        // Ako ne možemo da izvučemo body (npr Request objekat bez init.body), samo prosledi
        if (!fp) {
          log("cart/add detected but no fingerprint (body not readable) -> passthrough");
          return nativeFetch.apply(this, arguments);
        }

        cleanupCaches();
        const t = now();

        // Ako isti request vec leti -> vrati isti response (clone)
        const inflight = inflightAdds.get(fp);
        if (inflight && t - inflight.ts < DEDUPE_WINDOW_MS) {
          log("BLOCKED duplicate /cart/add (inflight)", fp);
          return inflight.promise.then((res) => res.clone());
        }

        // Ako isti request upravo zavrsen -> vrati cached response (clone)
        const recent = recentAdds.get(fp);
        if (recent && t - recent.ts < DEDUPE_WINDOW_MS && recent.response) {
          log("BLOCKED duplicate /cart/add (recent)", fp);
          return Promise.resolve(recent.response.clone());
        }

        const p = nativeFetch.apply(this, arguments).then((res) => {
          try {
            recentAdds.set(fp, { ts: now(), response: res.clone() });
          } catch (e) {
            // ignore clone errors
          }
          return res;
        }).finally(() => {
          const current = inflightAdds.get(fp);
          if (current && current.promise === p) {
            inflightAdds.delete(fp);
          }
        });

        inflightAdds.set(fp, { ts: t, promise: p });
        log("ALLOW /cart/add", fp);

        return p;
      } catch (err) {
        console.error("[atc-dedupe-fix] fetch patch error:", err);
        return window.fetch.apply(this, arguments);
      }
    };

    log("fetch patched");
  }

  function installSubmitLock() {
    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
        if (!form) return;

        const until = Number(form.dataset.atcLockUntil || 0);
        const t = now();

       
        if (until && t < until) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation?.();
          log("BLOCKED duplicate submit event", form);
          return;
        }

       
        form.dataset.atcLockUntil = String(t + SUBMIT_LOCK_MS);

        const submitButtons = form.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]');
        submitButtons.forEach((btn) => {
          try { btn.disabled = true; } catch (e) {}
        });

        log("Submit locked", form);

    
        window.setTimeout(() => {
        
          if (!document.contains(form)) return;

          const currentUntil = Number(form.dataset.atcLockUntil || 0);
          if (now() >= currentUntil) {
            delete form.dataset.atcLockUntil;
            submitButtons.forEach((btn) => {
              try { btn.disabled = false; } catch (e) {}
            });
            log("Submit unlocked", form);
          }
        }, SUBMIT_LOCK_MS + 50);
      },
      true // capture
    );

    log("submit lock installed");
  }

  patchFetch();
  installSubmitLock();
})();